import React from 'react';
import { ThemeProvider } from 'styled-components';

export const ThemeConfig = {
  colors: {
    // New design system colors (forest green primary)
    primary: "hsl(155, 65%, 25%)",          // Forest green
    primaryHover: "hsl(155, 65%, 20%)",     // Darker forest green
    secondary: "hsl(200, 65%, 55%)",        // Scientific blue accent

    // Legacy color mappings (updated to match design system)
    darkBlue: "hsl(155, 65%, 25%)",         // Maps to primary forest green
    darkerBlue: "hsl(155, 65%, 20%)",       // Maps to primary hover
    skyBlue: "hsl(200, 65%, 55%)",          // Maps to secondary accent blue

    // Neutral colors
    darkGrey: "hsl(0, 0%, 15%)",            // Text primary
    lightGrey: "hsl(0, 0%, 88%)",           // Border color
    grey: "hsl(0, 0%, 60%)",                // Text muted
    text: "#fff",
    placeholder: "hsl(0, 0%, 60%)",
    dark: "hsl(155, 65%, 20%)",

    // Semantic colors
    green: "hsl(140, 65%, 45%)",            // Success
    lightGreen: "hsl(140, 65%, 55%)",       // Success light
  },
  fonts: ["Inter", "Segoe UI", "Roboto", "Helvetica Neue", "Arial"],
  fontSizes: {
    small: "0.75rem",      // 12px
    medium: "1rem",        // 16px
    large: "1.25rem",      // 20px
  },
};

const Theme = ({ theme = {}, children }) => (
  <ThemeProvider
    theme={{
      colors: {
        ...ThemeConfig.colors,
      },
      fonts: ThemeConfig.fonts,
      fontSizes: ThemeConfig.fontSizes,
    }}
  >
    {children}
  </ThemeProvider>
);

export default Theme;
